import { getAnalytics } from "firebase/analytics"
import { FirebaseError, initializeApp } from "firebase/app"
import {
  getAuth,
  type NextOrObserver,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  type User,
} from "firebase/auth"

import { InvalidCredentialError } from "@/lib/errors"

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
const firebaseAuth = getAuth(app)

firebaseAuth.languageCode = "ja"

export const analytics = getAnalytics(app)

export const auth = {
  signInWithEmailAndPassword: (email: string, password: string) =>
    signInWithEmailAndPassword(firebaseAuth, email, password).catch((e) => {
      if (e instanceof FirebaseError && e.code === "auth/invalid-credential") {
        throw new InvalidCredentialError()
      }

      throw e
    }),
  onAuthStateChanged: (nextOrObserver: NextOrObserver<User>) =>
    onAuthStateChanged(firebaseAuth, nextOrObserver),
  signOut: () => signOut(firebaseAuth),
  currentUser: () => firebaseAuth.currentUser,
} as const
